
<div class="container-fluid scrollable scrollSize">

  <ng-template #tooltipTemplate><span translate>T_BACK_OFFICE_FIELD_ERROR_TOOLTIP_PHONE</span><br>
    <div *ngFor="let phone of listPhone">{{phone}}</div>
    <span translate>T_BACK_OFFICE_FIELD_ERROR_TOOLTIP_EMAIL</span>
    <div *ngFor="let email of listEmail">{{email}}</div>
  </ng-template>
  <h2 translate>T_CONTACT_MANAGEMENT_TITLE</h2>

  <!-- Localization default contacts data -->
  <div class="row">
    <ng-container *ngIf="localization">
      <!-- title -->
      <div class="ui-grid-col-4">
        <p class="default-title"><strong translate>Default localization contacts </strong><span>({{localization.country}})</span></p>
      </div>

      <!-- Localization support contact data -->
      <app-contact-details
        (onEditFieldBlur)="updateFieldLocalization($event)"
        *ngIf="localization.supportContact"
        [contactName]="'T_SUPPORT_CCC_TITLE'"
        [contactType]="ContactTypeEnum.SUPPORT"
        [contact]="localization.supportContact"></app-contact-details>

      <!-- Localization sales contact data -->
      <app-contact-details
        (onEditFieldBlur)="updateFieldLocalization($event)"
        *ngIf="localization.salesContact"
        [contactName]="'T_SUPPORT_SALES_TITLE'"
        [contactType]="ContactTypeEnum.SALES"
        [contact]="localization.salesContact"></app-contact-details>

      <!-- Localization save the data -->
      <div  class="save-error-container align-right">
        <span *ngIf="!isLocalizationValid()" class="align-left error-message" translate>T_BACK_OFFICE_FIELD_ERROR
          <em [tooltip]="tooltipTemplate" class="fa fa-info-circle fa-lg" containerClass="tooltip-error" placement="left"></em>
        </span>
        <button (click)="saveLocalization()" [disabled]="!isLocalizationValid()" class="btn btn-default btn-gray" translate type="button">T_BUTTON_SAVE</button>
      </div>
    </ng-container>
  </div>

  <!-- table with partners data -->
  <p-table #tt [columns]="cols" [paginator]="true" [rows]="10" [value]="(partners | async)" dataKey="name" styleClass="express-datatable-style">
    <ng-template pTemplate="emptymessage" >
      <tr>
        <td [attr.colspan]="4" translate>T_CONTACT_NO_PARTNER_FOUND</td>
      </tr>
    </ng-template>
    <ng-template let-columns pTemplate="header">
      <tr>
        <th scope="col" style="width: 2.25em"></th>
        <th *ngFor="let col of cols"  [pSortableColumn]="col.field" scope="col">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      <tr>
        <th scope="col" style="width: 2.25em"></th>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <input (input)="tt.filter($event.target.value, col.field, 'contains')" *ngIf="col.field === 'name'" pInputText placeholder="Search" type="text">
        </td>
      </tr>
    </ng-template>
    <ng-template let-columns="columns" let-expanded="expanded" let-partner pTemplate="body">
      <tr>
        <td>
          <a [pRowToggler]="partner" href="#">
            <em [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></em>
          </a>
        </td>
        <td>{{partner.name}}</td>
        <td></td>
        <td></td>
      </tr>
    </ng-template>
    <ng-template  let-partner pTemplate="expandedrow">
      <tr>
        <td></td>
        <td>
          <div class="align-left"><strong translate>{{partner?.name}}</strong></div>
          <div class="align-left">{{partner?.role}}</div>
        </td>
        <td>
          <div class="align-left "><strong translate>T_SUPPORT_CCC_TITLE</strong></div>
          <div class="align-left"><span translate>T_SUPPORT_PHONE_NUMBER</span> :
            <span (blur)="updateFieldContact(partner, ContactTypeEnum.SUPPORT, ContactFieldEnum.PHONE, $event)" class="phone-field"
                  contenteditable="true">{{partner?.supportContact.phone}}</span>
          </div>
          <div class="align-left"><span translate>T_SUPPORT_EMAIL</span> :
            <span (blur)="updateFieldContact(partner, ContactTypeEnum.SUPPORT, ContactFieldEnum.EMAIL, $event)" class="email-field"
                  contenteditable="true">{{partner?.supportContact.email}}</span>
          </div>
        </td>
        <td>
          <div class="align-left editableContent"><strong translate>T_SALES_TITLE</strong></div>
          <div class="align-left"><span translate>T_SUPPORT_PHONE_NUMBER</span> :
            <span (blur)="updateFieldContact(partner, ContactTypeEnum.SALES, ContactFieldEnum.PHONE, $event)" class="phone-field"
                  contenteditable="true">{{partner?.salesContact.phone}}</span>
          </div>
          <div class="align-left"><span translate>T_SUPPORT_EMAIL</span> :
            <span (blur)="updateFieldContact(partner, ContactTypeEnum.SALES, ContactFieldEnum.EMAIL, $event)" class="email-field"
                  contenteditable="true">{{partner?.salesContact.email}}</span>
          </div>
          <div *ngIf="partner" class="align-right">
                <span *ngIf="!isValid(partner)" class="align-left error-message" translate>T_BACK_OFFICE_FIELD_ERROR
                <em [tooltip]="tooltipTemplate" class="fa fa-info-circle fa-lg" containerClass="tooltip-error"
                   placement="left"></em>
                 </span>
            <button (click)="save(partner)" [disabled]="!isValid(partner)" class="btn btn-default btn-gray" translate
                    type="button">T_BUTTON_SAVE
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
